import {
  Button,
  Flex,
  Image,
  IconButton,
  Drawer,
  DrawerBody,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
  VStack,
  HStack,
  Text,
} from '@chakra-ui/react';
import { HamburgerIcon } from '@chakra-ui/icons';
import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { handleLogout } from '../../slice/appSlice';
import logo from './logo.jpg';
import './Navbar.css';

function Navbar({ isLoggedIn }) {
  const dispatch = useDispatch();
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <div className="navbar-wrapper">
      <div className="navbar-container">

        {/* Logo Section */}
        <Flex align="center" justify="space-between" width="100%">
          <Flex align="center">
            <Image marginX="10px" h="56px" src={logo} alt="SAFECERT Logo" />
            <NavLink to="/" className="navbar-logo-text">SAFECERT</NavLink>
          </Flex>

          {/* Desktop Links */}
          <HStack
            spacing="20px"
            className="navbar-links-desktop"
            display={{ base: 'none', md: 'flex' }}
          >
            <NavLink exact activeClassName="navbar-selected" to="/">Home</NavLink>

            {!isLoggedIn && (
              <>
                <NavLink exact activeClassName="navbar-selected" to="/login">Login</NavLink>
                <NavLink exact activeClassName="navbar-selected" to="/signup">Sign Up</NavLink>
              </>
            )}

            {isLoggedIn && (
              <>
                <NavLink exact activeClassName="navbar-selected" to="/change-password">
                  Change Password
                </NavLink>
                <NavLink to="/" onClick={() => dispatch(handleLogout())}>
                  Log Out
                </NavLink>
              </>
            )}

            <NavLink to="/verify">
              <Button
                backgroundColor="#007bff"
                color="white"
                _hover={{ bg: '#0069d9', color: 'whitesmoke' }}
              >
                Verify Certificate
              </Button>
            </NavLink>
          </HStack>

          {/* Hamburger Icon (Mobile only) */}
          <IconButton
            icon={<HamburgerIcon />}
            display={{ base: 'flex', md: 'none' }}
            onClick={onOpen}
            aria-label="Open menu"
            variant="outline"
            colorScheme="blue"
          />
        </Flex>

        {/* Drawer (for mobile menu) */}
        <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
          <DrawerOverlay />
          <DrawerContent>
            <DrawerCloseButton />
            <DrawerBody>
              <VStack spacing="24px" mt="60px" align="start">
                <NavLink exact to="/" onClick={onClose}>
                  <Text fontSize="lg">Home</Text>
                </NavLink>

                {!isLoggedIn && (
                  <>
                    <NavLink exact to="/login" onClick={onClose}>
                      <Text fontSize="lg">Login</Text>
                    </NavLink>
                    <NavLink exact to="/signup" onClick={onClose}>
                      <Text fontSize="lg">Sign Up</Text>
                    </NavLink>
                  </>
                )}

                {isLoggedIn && (
                  <>
                    <NavLink exact to="/change-password" onClick={onClose}>
                      <Text fontSize="lg">Change Password</Text>
                    </NavLink>
                    <NavLink
                      to="/"
                      onClick={() => {
                        dispatch(handleLogout());
                        onClose();
                      }}
                    >
                      <Text fontSize="lg">Log Out</Text>
                    </NavLink>
                  </>
                )}

                <NavLink to="/verify" onClick={onClose}>
                  <Button
                    backgroundColor="#007bff"
                    color="white"
                    width="100%"
                    _hover={{ bg: '#0069d9', color: 'whitesmoke' }}
                  >
                    Verify Certificate
                  </Button>
                </NavLink>
              </VStack>
            </DrawerBody>
          </DrawerContent>
        </Drawer>
      </div>
    </div>
  );
}

Navbar.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
};

export default Navbar;
